import { useTranslation } from "react-i18next";
import DotIcon from "@material-ui/icons/FiberManualRecord";
import { Group } from "@dashboard-v3/api";
import useClipboard from "utils/useClipboard";
import { Box, Link, Tooltip } from "@material-ui/core";

export default function EmailAndSource({ group }: { group: Group }) {
  const { t } = useTranslation("accounts");
  const { id, email, sourceType, sourceLabel } = group;

  return (
    <Box
      display="flex"
      flexWrap="wrap"
      flexDirection="column"
      style={{ textWrap: "initial" }}
    >
      <GroupId key={`group-id-${id}`} id={id} />
      <Box>
        {email && (
          <Tooltip title={email}>
            <span key={`email-${id}`}>{email}</span>
          </Tooltip>
        )}
        {sourceType && email && (
          <DotIcon
            key={`dot-source-${id}`}
            style={{ fontSize: ".5rem", margin: "0 10px" }}
          />
        )}
        {sourceType && (
          <span key={`source-${id}`} style={{ textTransform: "capitalize" }}>
            {t("source")}: {sourceTypes[sourceType]}
            {sourceLabel ? ` - ${sourceLabel}` : ""}
          </span>
        )}
      </Box>
    </Box>
  );
}

const sourceTypes = {
  MANUAL: "Manual",
  GAPPS: "Google Apps",
  OFFICE365: "Office 365",
  LDAP: "LDAP",
};

export function GroupId({ id }: { id: string }) {
  const copyToClipboard = useClipboard();

  return (
    <span>
      ID:{" "}
      <Link
        href="#"
        onClick={event => {
          event.preventDefault();
          event.stopPropagation();
          copyToClipboard(id);
        }}
      >
        {id}
      </Link>
    </span>
  );
}
